import { render, staticRenderFns } from "./CardLecturer.vue?vue&type=template&id=e9ee80c2&scoped=true"
import script from "./CardLecturer.vue?vue&type=script&lang=js"
export * from "./CardLecturer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ee80c2",
  null
  
)

export default component.exports